
export function ListEntryTip({text} : {text : string}) {
    return <div className="list-entry-tip-outer small-margin" style={{height: "fit-content", padding: "1.2rem"}}>
        <span className="small-margin list-entry-tip-span full-wide"> {text} </span>
    </div>
}